import {getCurrentUser} from "@/API/UsersAPIs";
import { getUserPermissions } from "@/API/PermissionsAPIs";
import {userSidebarLinks} from "@/Utils/roles"
export const setAccessToken = (token) => localStorage.setItem('token', token);

export const getAccessToken = () => localStorage.getItem('token') || '';

export const resetAccessToken = () => localStorage.removeItem('token');

export const isAuthenticated = async (store) => {
  if(!getAccessToken()) return false;
    try {
      let currentUser = await getCurrentUser();
      const isBusinessOwner = currentUser.business.length > 0;
      if(!currentUser.business || currentUser.business.length < 1){
        currentUser.business = currentUser.business_control;
      }
      const UserPermissions = await getUserPermissions({
        'businessId': currentUser.business[0]?.id,
        'branchId': currentUser.business[0]?.branches[0]?.id,
        'userId': currentUser.id
      });

      if (currentUser) {
        if (isBusinessOwner) {
          const permissions = `branch.${currentUser.business[0]?.branches[0]?.id}.permissions.read`;
          UserPermissions.permissions.push(permissions);
  
        }
        store.commit("User/setUser", currentUser);
        store.commit('setSidebarLinks', userSidebarLinks(currentUser, UserPermissions.permissions, isBusinessOwner));
        store.commit('setUserPermissions', UserPermissions);
        return true;
      }else {
        console.log("error", "couldn't get user")
        resetAccessToken();
        return false;
      }
    } catch (error) {
      console.log("error", error)
      resetAccessToken();
      window.location = '/';
      return false;
    }
}

export const resetUser = async (store)=>{
  resetAccessToken();
  store.commit('resetUser');
}
